import { useMemo } from 'react';
import { isBefore } from 'date-fns';

import { useTokenClaims, useTokensStore } from '@app-velocity/request-gateway';

import { useGetCurrentUserQuery } from '../queries/useGetCurrentUserQuery';

export const useCurrentUser = (refetch = true) => {
  const accessToken = useTokensStore((state) => state.accessToken);
  const readTokenClaim = useTokenClaims();

  const isSuperAdmin = !!readTokenClaim('superAdmin');

  const isAuthorized = useMemo(() => !!accessToken, [accessToken]);

  const {
    data: currentUserInfo,
    isLoading,
    isError,
  } = useGetCurrentUserQuery(isAuthorized, refetch);

  const planPeriodValid = useMemo(() => {
    if (!currentUserInfo) return false;

    const { subscribedUntil } = currentUserInfo;

    return subscribedUntil && isBefore(new Date(), new Date(subscribedUntil));
  }, [currentUserInfo]);

  if (isLoading) return null;

  if (!isAuthorized || isError) {
    return {
      authorized: false,
    };
  }

  if (!currentUserInfo) return null;
  const { tier, subscribedUntil, resubscribe } = currentUserInfo;

  return {
    id: currentUserInfo.id,
    email: currentUserInfo.email,
    marketingAccepted: currentUserInfo?.marketingAccepted || null,
    authorized: true,
    isSuperAdmin: !!isSuperAdmin,
    tier,
    subscribedUntil,
    resubscribe,
    planPeriodValid,
  };
};
